import Header from "../components/header/Header";
import Footer from "../components/footer/Footer";
import appPlay from "../assets/images/app-play.svg";
import googlePlay from "../assets/images/google-play.svg";
import mobilApp from "../assets/images/mobil-app.webp";
import whyChooseIcon1 from "../assets/images/whyChoose-icon1.svg";
import whyChooseIcon2 from "../assets/images/whyChoose-icon2.svg";
import whyChooseIcon3 from "../assets/images/whyChoose-icon3.svg";
import whyChooseIcon4 from "../assets/images/whyChoose-icon4.svg";
import { scrollToTop } from "../utils/Helper";
import { useEffect } from "react";
const Howitwork = () => {
  useEffect(() => {
    scrollToTop();
  }, []);
  return (
    <div className="wrapper">
      <Header isBackEnable={false} />
      <main className="main-curve-top">
        <div className="happy-left">&nbsp;</div>
        <div className="happy-right">&nbsp;</div>
        <section className="howitwork-sec">
          <div className="container">
            <div className="row">
              <div className="col-12">
                <div className="howitwork-content">
                  <h1 className="title h1">
                    Simplified Project Management in Three Steps
                  </h1>
                  <p>
                    At HE, we streamline project management with a user-friendly
                    approach that ensures efficiency, collaboration, and
                    profitability. Here’s how it works:
                  </p>
                </div>
                <div className="cardstepBg">
                  <div className="cardstep">
                    <span>1</span>
                    <h2>Set Up & Customize Your Workspace</h2>
                  </div>
                  <ul className="management-list">
                    <li>Create your project with ease.</li>
                    <li>Customize workflows to match your process.</li>
                    <li>
                      Invite team members and clients for seamless
                      collaboration.
                    </li>
                  </ul>
                </div>
                <div className="cardstepBg">
                  <div className="cardstep">
                    <span>2</span>
                    <h2>Manage & Automate Tasks Effortlessly</h2>
                  </div>
                  <ul className="management-list">
                    <li>
                      Assign tasks, set deadlines, and track progress in
                      real-time.
                    </li>
                    <li>Automate repetitive workflows to save time.</li>
                    <li>
                      Use integrated tools for communication, file sharing, and
                      approvals.
                    </li>
                  </ul>
                </div>
                <div className="cardstepBg">
                  <div className="cardstep">
                    <span>3</span>
                    <h2>Track Performance & Optimize for Success</h2>
                  </div>
                  <ul className="management-list">
                    <li>
                      Gain insights with data-driven reports and analytics.
                    </li>
                    <li>Monitor client feedback and refine processes.</li>
                    <li>
                      Scale your projects with adaptable, flexible solutions.
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </section>
        <section className="whychoose">
          <div className="container">
            <h2>Why Choose HE?</h2>
            <div className="row">
              <div className="col-lg-4 col-md-4">
                <div className="whychoose-card">
                  <h3>Intuitive & Easy-to-Use</h3>
                  <p>
                    No steep learning curve, just seamless project execution.
                  </p>
                </div>
              </div>
              <div className="col-lg-4 col-md-4">
                <div className="whychoose-card">
                  <h3>Collaboration-Driven</h3>
                  <p>Keep your clients and team on the same page.</p>
                </div>
              </div>
              <div className="col-lg-4 col-md-4">
                <div className="whychoose-card">
                  <h3>Automation & Insights</h3>
                  <p>Reduce manual work and make data-backed decisions.</p>
                </div>
              </div>
            </div>
          </div>
        </section>
        <section className="business-sec">
          <div className="container">
            <div className="row">
              <div className="col-lg-6 col-md-6">
                <div className="business-content">
                  <h3>Your Business, Your Rules – Access It Anywhere</h3>
                  <p>
                    Take control of your projects with our powerful mobile and
                    web applications. Whether you’re in the office or on the
                    move, stay connected with your clients, streamline
                    workflows, and maximize profits—all from one intuitive
                    platform.
                  </p>
                  <div className="play-btn-group">
                    <a href="#">
                      {" "}
                      <img src={appPlay} alt="appPlay" />
                    </a>
                    <a href="#">
                      {" "}
                      <img src={googlePlay} alt="googlePlay" />
                    </a>
                  </div>
                </div>
              </div>
              <div className="col-lg-6 col-md-6">
                <img src={mobilApp} alt="mobilApp" className="mobilApp" />
              </div>
            </div>
          </div>
        </section>
        <section className="whyChoose-sec">
          <div className="container">
            <div className="head-top-content">
              <h2>Why Choose Us?</h2>
              <p>
                Effortless Project Management, Seamless Client Collaboration
              </p>
            </div>
            <div className="row">
              <div className="col-lg-3 col-md-6 col-sm-6">
                <div className="whyChoose-content">
                  <img
                    src={whyChooseIcon1}
                    alt="whyChooseIcon1"
                    className="whyChooseIcon"
                  />
                  <h4>Client-Centric Approach</h4>
                  <p>
                    We prioritize transparent communication and strong client
                    relationships to ensure smooth collaboration and lasting
                    trust.
                  </p>
                </div>
              </div>
              <div className="col-lg-3 col-md-6 col-sm-6">
                <div className="whyChoose-content">
                  <img
                    src={whyChooseIcon2}
                    alt="whyChooseIcon2"
                    className="whyChooseIcon"
                  />
                  <h4>Efficiency & Automation</h4>
                  <p>
                    Automate processes, reduce manual effort, and keep projects
                    on track with smart, time-saving solutions.
                  </p>
                </div>
              </div>
              <div className="col-lg-3 col-md-6 col-sm-6">
                <div className="whyChoose-content">
                  <img
                    src={whyChooseIcon3}
                    alt="whyChooseIcon3"
                    className="whyChooseIcon"
                  />
                  <h4>Data-Driven Insights</h4>
                  <p>
                    Make informed choices with powerful analytics and real-time
                    reporting for improved project performance.
                  </p>
                </div>
              </div>
              <div className="col-lg-3 col-md-6 col-sm-6">
                <div className="whyChoose-content">
                  <img
                    src={whyChooseIcon4}
                    alt="whyChooseIcon4"
                    className="whyChooseIcon"
                  />
                  <h4>Flexible & Scalable Solutions</h4>
                  <p>
                    Whether you’re a freelancer, small business, or enterprise,
                    HE adapts to your needs and grows with you.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </section>
      </main>
      <Footer />
    </div>
  );
};

export default Howitwork;
